import { useContext } from "react"
import { AppContext } from "../App"
import { MdMenu } from "react-icons/md";
import logo2 from '../assets/logo2.png';

export default function TopBar(props) {

  const appContext = useContext(AppContext);
  const menuItems = [
    { item: 'home', label: 'Home' },
    { item: 'books', label: 'Books' },
    { item: 'videos', label: 'Videos' },
    { item: 'journals', label: 'Journals' },
    { item: 'stories', label: 'Stories' },
    { item: 'account', label: 'Account' },
  ];

  function goTo(item) {
    appContext.navTo({
      item,
    })
  }

  return (
    <div
      className="TopBar"
    >
      <div className="body">
        <div
          className="container d-flex justify-content-between"
          style={{
            height: "100%",
          }}
        >
          <div
            className="align-self-center d-flex"
            style={{
              height: "100%",
              flexShrink: 1,

            }}
          >
            <MdMenu
              className="align-self-center mMobileOnly"
              size={32}
              style={{
                flexShrink: 0,
                cursor: "pointer",
                marginRight: "0px"
              }}
              onClick={appContext.openSideBar}
            />

            <img
              src={logo2}
              alt="MIKA KENYATA"
              style={{
                height: "50px",
                width: "auto",
                margin: "0",
                flexShrink: 0,
                cursor: "pointer",
              }}
              className="align-self-center mDesktopOnly"
              onClick={() => {
                appContext.navTo({
                  item: 'home',
                })
              }}
            />

            <img
              src={logo2}
              alt="MIKA KENYATA"
              style={{
                height: "35px",
                width: "auto",
                margin: "0",
                flexShrink: 0,
                cursor: "pointer",
              }}
              className="align-self-center mMobileOnly"
              onClick={() => {
                appContext.navTo({
                  item: 'home',
                })
              }}
            />
          </div>

          <div
            className="DesktopMenu align-self-center mNoMargin mNoPadding"
            style={{
              height: "100%",
              width: "auto",
              flexShrink: 0,
            }}
          >

            {
              menuItems.map((menuItem) => {
                const isActive = (
                  appContext.navItem === menuItem.item ||
                  (!appContext.navItem && menuItem.item === 'home')
                );

                return (
                  <div
                    className="mMenuItem"
                    key={menuItem.item}
                    onClick={() => goTo(menuItem.item)}
                    data-active={isActive}
                  >
                    {menuItem.label}
                  </div>
                )
              })
            }

          </div>

          <div
            className="align-self-center mNoMargin mNoPadding mMobileOnly"
            style={{
              height: "100%",
              width: "auto",
              flexShrink: 0,
            }}
          >

            <div
              className="mMenuItem"
            >
              <button
                className="btn btn-primary font-bold btn-rounded"
                style={{
                  fontSize: "14px"
                }}
                onClick={() => goTo("account")}
              >
                Account
              </button>
            </div>

          </div>

        </div>
      </div>
    </div>
  )
}
